// extracted by mini-css-extract-plugin
export default {"card":"ListComment_card__tf8M8","title":"ListComment_title__r4tLW","box":"ListComment_box__3tCY0"};